import { TableCell, TableCellLayout, tokens } from '@fluentui/react-components';
import { type Cell as FluentUICell, flexRender } from '@tanstack/react-table';
import { px } from '@this/app-shared/dist/tools/styles.js';
import { useMemo } from 'react';
import { ResizableTableCellBlank } from '../cell-blank/index.js';
import { useStyles } from './styles.js';

type CellProps<TData> = {
    cell: FluentUICell<TData, unknown>;
    padContainerValue?: number | string;
    columnSizes: Record<string, number>;
    position?: 'first' | 'last';
};

export function Cell<TData>({ cell, padContainerValue, columnSizes, position }: CellProps<TData>) {
    const styles = useStyles();

    const width = useMemo(() => {
        return `calc(${px(columnSizes?.[cell.column.id])} - (${2} * ${tokens.spacingHorizontalS}))`;
    }, [cell.column.id, columnSizes]);

    return (
        <>
            {position === 'first' && <ResizableTableCellBlank size={padContainerValue ?? 0} />}

            <TableCell
                style={{
                    width,
                    minWidth: width,
                    maxWidth: width,
                }}
            >
                <TableCellLayout className={styles.cellLayout}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TableCellLayout>
            </TableCell>

            {position === 'last' && <ResizableTableCellBlank size={padContainerValue ?? 0} />}
        </>
    );
}
